import { EnvType } from "../services";
import { IApiClient } from "../api-client";
import { StorageKind } from "../Types/storage-kind";
import { ExcelProperties } from "../../../Components/Importer/importer";

interface ILegacyImporterApiClient {
  Find(kind: StorageKind): Promise<any>;
  GetTokenCounter(): Promise<any>;
  AddTokenCounter(): Promise<any>;
  Load(file: ExcelProperties): Promise<any>;
  Operation(request: any): Promise<any>;
  DeleteExcelFiles(file: ExcelProperties): Promise<any>;
  DownloadExcelFile(file: ExcelProperties): Promise<any>;
}

export default class LegacyImporterApiClient implements ILegacyImporterApiClient {
  readonly servicePort = 9519;
  readonly serviceBaseUrl = "legacy-importer-service/api";

  legacyImporterApiClient: IApiClient;

  constructor(legacyImporterApiClient: IApiClient, envType: EnvType) {
    this.legacyImporterApiClient = legacyImporterApiClient;
    if (envType === "local") this.legacyImporterApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }

  async Find(kind: StorageKind): Promise<any> {
    return await this.legacyImporterApiClient.get(`${this.serviceBaseUrl}/find/${kind}`);
  }

  async GetTokenCounter(): Promise<any> {
    return await this.legacyImporterApiClient.get(`${this.serviceBaseUrl}/token`);
  }

  async AddTokenCounter(): Promise<any> {
    return await this.legacyImporterApiClient.post(`${this.serviceBaseUrl}/token`);
  }

  async Load(file: ExcelProperties): Promise<any> {
    return await this.legacyImporterApiClient.post(`${this.serviceBaseUrl}/load`, file);
  }

  async DeleteExcelFiles(file: ExcelProperties): Promise<any> {
    return await this.legacyImporterApiClient.delete(`${this.serviceBaseUrl}/delete`, file);
  }

  async Operation(request: any): Promise<any> {
    return await this.legacyImporterApiClient.post(`${this.serviceBaseUrl}/ops`, request);
  }

  async DownloadExcelFile(file: ExcelProperties): Promise<any> {
    return await this.legacyImporterApiClient.getWithHeaders(
      `${this.serviceBaseUrl}/download/${file.storageId}/${file.fileName}`,
      "arraybuffer"
    );
  }

  //------Utils------
  GetApiUrl(): string {
    return this.legacyImporterApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
